import type { PropsWithChildren } from 'react';
import { ContestStatus } from '@betterpool/api-types/contests-service';

import NotFoundScreen from '~/domains/common/components/NotFoundScreen/NotFoundScreen';
import { PageLayout } from '~/domains/common/app/PageLayout';
import { getVisibleUserEntriesCount } from '~/domains/contest/domains/common/utils/pickControl';

import { useIsGamecenterEnabled } from '../../hooks/useIsGamecenterEnabled';
import { useContestContext } from '../../context/ContestContext/ContestContext';
import useIsCommissioner from '../../utils/useIsCommissioner';

function GamecenterEnabledCheck({
  children,
  isOnlyNotScheduled,
}: PropsWithChildren<{ isOnlyNotScheduled?: boolean }>) {
  const { contest } = useContestContext();
  const { isSettled, isEnabled } = useIsGamecenterEnabled(
    contest?.contest_type,
    contest?.league.sport
  );
  const { shouldAllowCommissionerAccess } = useIsCommissioner();

  if (isOnlyNotScheduled && contest?.status === ContestStatus.SCHEDULED) {
    return (
      <PageLayout>
        <NotFoundScreen />
      </PageLayout>
    );
  }

  if (!isSettled) {
    return null;
  }

  if (!isEnabled) {
    return (
      <PageLayout>
        <NotFoundScreen />
      </PageLayout>
    );
  }

  if (
    contest?.is_after_first_late_swap_deadline &&
    getVisibleUserEntriesCount(contest) === 0 &&
    !contest.public_viewing &&
    !shouldAllowCommissionerAccess
  ) {
    return (
      <PageLayout>
        <NotFoundScreen />
      </PageLayout>
    );
  }

  return children;
}

export default GamecenterEnabledCheck;
